<div *ngIf="show$ | async" class="blackscreen" (click)="close()" [@blackScreen]></div>
<ng-template #modalContent></ng-template>
